export enum PayrollSettingsViewTypeEnum {
  None,
  EditDistributionsModal,
}
